export const setDetails = ({ id, details }) => ({
	type: 'SET_DETAILS',
	id,
	details
});